import {Component, Fragment} from "preact";
import Admin from "../../../../services/admin";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import MoneyFormatter from "../../utils/money-formatter";
import {FiltersRow, InputFilter} from "../../utils/table-utils";
import {DateHelperFilter, PerPageFilter, TableFormatter} from "../../utils/form-utils";
import PopupLayout from "../site/popup-layout";
// import PopupLayout from "../layout/popup-layout";

import {
    ManagerTransactionHistory as AwrabetManagerTransactionHistory, 
    ManagerTransactionHistoryPopup as AwrabetManagerTransactionHistoryPopup 
} from "../../../awrabet/desktop-components/user/manager-transaction-history.jsx";

export let ManagerTransactionPopup = username => window.open(
    '/admin/transactions/affiliate/'+ encodeURIComponent(username),
    'topupWindow',
    'width=1100,height=600,scrollbars=yes'
);

export class ManagerTransactionHistoryPopup extends AwrabetManagerTransactionHistoryPopup {
    render() {
        return <PopupLayout>
            <div class="px-0 py-3 bg-white border text-gray-900">
                <div class="py-2 text-lg text-center"><Trans>Storico Movimenti</Trans></div>
                <ManagerTransactionHistory username={this.props.username} />
            </div>
        </PopupLayout>;
    }
}

export class ManagerTransactionHistory extends AwrabetManagerTransactionHistory {

    tableColumns() {
        return [
            <strong class="block text-left body-bg-color"><Trans>ID</Trans></strong>,
            <strong class="block text-left body-bg-color"><Trans>Struttura Operante</Trans></strong>,
            <strong class="block text-left body-bg-color"><Trans>Struttura Destinataria</Trans></strong>,
            <strong class="block text-center body-bg-color"><Trans>Data</Trans></strong>,
            <strong class="block text-center body-bg-color"><Trans>Descrizione</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Importo</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Saldo Operante</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Fido Operante</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Saldo Destinataria</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Fido Destinataria</Trans></strong>
        ];
    }

    renderUsernameWithIcon(user) {
        let icon = <i class="fa fa-cash-register"/>;
        let username = user.company;

        if (user.idaccess === 100) {
            icon = <i className="fa fa-user main-color"/>;
        }

        if (user.company.indexOf('] ') !== -1) {
            const split = user.company.split(' ');
            username = split[1];

            switch (split[0]) {
                case '[5]':
                    icon = <span class="inline-block w-4 h-4 font-mono text-white bg-green-800 font-normal text-center text-[11px]">Sh</span>;
                    break;
                case '[4]':
                    icon = <span class="inline-block w-4 h-4 font-mono text-white bg-orange-800 font-normal text-center text-[11px]">A</span>;
                    break;
                case '[3]':
                    icon = <span class="inline-block w-4 h-4 font-mono text-white bg-violet-800 font-normal text-center text-[11px]">Sa</span>;
                    break;
                case '[2]':
                    icon = <span class="inline-block w-4 h-4 font-mono text-white bg-red-800 font-normal text-center text-[11px]">M</span>;
                    break;
                case '[1]':
                    icon = <span class="inline-block w-4 h-4 font-mono text-white bg-fuchsia-800 font-normal text-center text-[11px]">W</span>;
                    break;
            }
        }

        return <strong class="whitespace-pre">{icon} {username}</strong>;
    }

    tableDataMapper(row) {
        return [
            <span class="block px-2 text-left">{row.idtransazione}</span>,
            <span class="block px-2 text-left">
                {this.renderUsernameWithIcon(row.sender)}
                <span class="block text-xxs betstable-cell-text-color-dark">#{row.sender.idstruttura}</span>
            </span>,
            <span class="block px-2 text-left">
                {this.renderUsernameWithIcon(row.receiver)}
                <span class="block text-xxs betstable-cell-text-color-dark">#{row.receiver.idstruttura}</span>
            </span>,
            <span class="block px-2 text-center">
                {new Date(row.ts * 1000).toLocaleDateString(undefined, {day:'2-digit', month:'2-digit', year:'numeric'})}
                &nbsp;
                {new Date(row.ts * 1000).toLocaleTimeString(undefined, {hour: '2-digit', minute: '2-digit', hourCycle: 'h23'})}
            </span>,
            <span class="block px-2 text-center">{!!row.description.rawmessage? row.description.rawmessage : row.description.message}</span>,
            <span class={'block px-2 text-right '+ (parseFloat(row.amount)<0? 'text-red-600' : 'text-green-600')}><MoneyFormatter value={row.amount} currency={row.currency} /></span>,
            <span class="block px-2 text-right"><MoneyFormatter value={row.new_sender_balance} currency={row.sender.currency} /></span>,
            <span class="block px-2 text-right"><MoneyFormatter value={row.new_sender_fido} currency={row.sender.currency} /></span>,
            <span class="block px-2 text-right"><MoneyFormatter value={row.new_receiver_balance} currency={row.receiver.currency} /></span>,
            <span class="block px-2 text-right"><MoneyFormatter value={row.new_receiver_fido} currency={row.receiver.currency} /></span>
        ];
    }

    render() {
        return <div class="px-3">
            <FiltersRow class="p-2 text-sm items-end justify-center">
                <DateHelperFilter
                    {...this.state.dateFilter}
                    onInput={
                        (dateFilter) => {
                            this.state.dateFilter = dateFilter;
                            this.setState(this.state);
                        }
                    }
                />
                <label class="mx-px px-2">
                    <span class="block text-xs"><Trans>Username</Trans></span>
                    <InputFilter
                        type="text"
                        class="w-40 px-2 py-1 leading-6 rounded border"
                        value={this.state.username}
                        onInput={e => this.setState({username: e.target.value})}
                    />
                </label>
                <PerPageFilter
                    perPage={this.state.perPage}
                    pageList={[10,20,30,50,100]}
                    onInput={
                        ({perPage}) => {
                            this.state.perPage = perPage;
                            this.setState(this.state);
                        }
                    }
                />
                <a href="javascript:void(0);" class="button p-2 ml-5 main-text-color" onClick={e => this.performSearch()}>
                    <Trans>Avvia Ricerca <i class="fa fa-search" /></Trans>
                </a>
            </FiltersRow>
            <div class="text-xs mt-3">
                <TableFormatter
                    {...this.state.response}
                    style="font-family:'Arial rounded', Arial, sans-serif;"
                    columns={this.tableColumns()}
                    rowClass={'hover:bg-gray-200 border-b'}
                    rowDataMapper={this.tableDataMapper.bind(this)}
                    onNavigation={(newpage, newlowlimit) => this.changePage(newpage)}
                />
            </div>
        </div>;
    }
}